import { Box, MenuItem } from '@mui/material';
import { CustomSelect, CustomTextField, DialogBody, HorizontalForm } from '../../../common/components';

/**
 * Tab de configuración general del plan
 * Extraído del diálogo original para seguir el patrón de tabs
 */
const GeneralConfigTab = ({ selectedPlan, onInputChange, onSelectChange, branches }) => {
  return (
    <DialogBody sx={{ p: 2, minHeight: '65vh' }}>
      <HorizontalForm withBorder={false} sx={{ p: 1 }}>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
          <CustomTextField
            label="Nombre"
            name="name"
            value={selectedPlan.name || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomSelect
            label="Sucursal"
            name="branch"
            value={selectedPlan.branch ? selectedPlan.branch.description : ''}
            onChange={onSelectChange}
            size="medium"
          >
            {branches.map((branch) => (
              <MenuItem key={branch.uuid} value={branch.description}>
                {branch.description}
              </MenuItem>
            ))}
          </CustomSelect>
        </Box>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
          <CustomTextField
            label="Fecha inicio vigencia"
            name="effective_start_date"
            type="date"
            value={
              selectedPlan.effective_start_date
                ? new Date(selectedPlan.effective_start_date).toISOString().split('T')[0]
                : ''
            }
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Fecha baja"
            name="finish_date"
            type="date"
            onChange={onInputChange}
            size="medium"
            disabled
          />
        </Box>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
          <CustomTextField
            label="Cantidad de cuotas"
            name="installments_number"
            type="number"
            value={selectedPlan.installments_number || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Cantidad de contratos"
            name="contracts_number"
            type="number"
            value={selectedPlan.contracts_number || ''}
            onChange={onInputChange}
            size="medium"
          />
        </Box>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
          <CustomTextField
            label="Interés por mes (%)"
            name="interest_rate"
            type="number"
            value={selectedPlan.interest_rate || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Primer valor cuota ($)"
            name="first_installment_amount"
            type="number"
            value={selectedPlan.first_installment_amount || ''}
            onChange={onInputChange}
            size="medium"
          />
        </Box>
      </HorizontalForm>
    </DialogBody>
  );
};

export default GeneralConfigTab;
